import React from 'react'
import { Header } from 'components/Header'
import { Button, Flex } from '@workwhile/ui'
import { QueryStatus } from 'components/QueryStatus'
import { useTimeClocksContextValue } from '../context/TimeClocksProvider'
import { useTimeClocksWorkflowsContextValue } from '../context/TimeClocksWorkflowsProvider'

export const TimeClocksHeader = () => {
  const { state, actions } = useTimeClocksContextValue()
  const { createTimeClockFlow } = useTimeClocksWorkflowsContextValue()

  return (
    <Header
      title="Time Clocks"
      rightContent={
        <Flex alignItems="center" gap={2}>
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
          <Button
            variant="primary"
            kind="medium"
            disabled={state.companyId === null}
            onClick={createTimeClockFlow.open}
          >
            Register clock
          </Button>
        </Flex>
      }
    />
  )
}
